import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { ParcellaGiudiziale } from '../../../models/parcella-giudiziale';
import { SezioneParcelleGiudiziali } from '../../../models/sezioni/sezione-parcelle-giudiziali';
import { ParcelleGiudizialiEditComponent } from './parcelle-giudiziali-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [parcella-giudiziale-mod-edit]',
  templateUrl: 'parcella-giudiziale-mod-edit.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ParcellaGiudizialeModEdit {
  @Output() onReturn: EventEmitter<SezioneParcelleGiudiziali> = new EventEmitter<SezioneParcelleGiudiziali>();
  @ViewChild('formParcellaGiudizialeEdit') formParcellaGiudiziale: ParcelleGiudizialiEditComponent;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();


  inizializza(sezione: SezioneParcelleGiudiziali,
              parcellaGiudiziale: ParcellaGiudiziale,
              idSezioneLegali: string,
              idSezioneEconomica: string,
              urlUpdate: string,
              urlReadSezioneLegali: string,
              urlReadSezioneEconomica: string,
              urlGetScaglioni: string,
              tipoFascicolo: any,
              tipoPratica: number) {
    if(this.isPrd) {
      this.formParcellaGiudiziale.inizializza(sezione,
                                            parcellaGiudiziale,
                                            idSezioneLegali,
                                            idSezioneEconomica,
                                            urlUpdate,
                                            urlReadSezioneLegali,
                                            urlReadSezioneEconomica,
                                            urlGetScaglioni,
                                            tipoFascicolo,
                                            tipoPratica);
      }
    openModal('modalmodParcellaGiudiziale');
  }

  createForm() {
    if(this.isPrd) this.formParcellaGiudiziale.createForm();
  }

  manageModal(sezioneParcelleGiudiziali: SezioneParcelleGiudiziali) {
      closeModal('modalmodParcellaGiudiziale');
      this.onReturn.emit(sezioneParcelleGiudiziali);
  }
}
